import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import _ from 'lodash';
import { Match } from '../models/match';

@Injectable({
  providedIn: 'root'
})
export class MatchService {
  
  constructor(
    private httpClient: HttpClient,
  ) {}

  // [GET] round matches
  public getMatches(roundId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.matches, ':id', roundId), {
        params: {}, observe: 'response'
      });
  }

  // [PATCH] update match
  public updateMatch(match: Match): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.match, ':id', match.id || ''), match, {
        params: {}, observe: 'response'
      });
  }

  // [PATCH] change pieces (B&W)
  public changePieces(match: Match): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.matchPieces, ':id', match.id || ''), match, {
        params: {}, observe: 'response'
      });
  }
}

